import React, { Component } from 'react';
import ReactDOM from 'react-dom';
import { Tag } from 'antd';



class NodePP extends Component {

  onClick(){
    const rect = ReactDOM.findDOMNode(this).getBoundingClientRect();
    this.props.togglePP(this.props.data.key, rect);
  }

  render() {
    const selected = this.props.selected ? 'node-selected' : null;
    return (
      <Tag
        className = "NodePP"
        id={selected}
        color="blue"
        onClick = {() => this.onClick()}
      >
          {this.props.children}
      </Tag>
    );
  }

}

export default NodePP;



// WEBPACK FOOTER //
// ./src/components/PressurePoint/NodePP.js